module.exports = __webpack_public_path__ + "c9fe51158ba6b603e4d0b46b1154f32a.svg";